var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question",attrs:{"id":"preview"}},[_c('h2',{staticClass:"header"},[_vm._v(" "+_vm._s(_vm.$t('gift_giving_report.preview.title'))+" ")]),_c('div',{staticClass:"content"},[_c('ExamplePreview',{attrs:{"delivery-report":_vm.deliveryReport,"family-words":_vm.familyWords,"volunteer-words":_vm.volunteerWords}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }